import { HorizontalStack, HorizontalStackProps } from '@/components/utils/linearLayouts';
import { Children, ReturnComponent } from '@/utils/reactTypes';
import Info from '@mui/icons-material/Info';
import { IconButton, Tooltip, Typography } from '@mui/material';

export const InfoIconAnchor = ({
    children,
    disabledHelperText = '',
    description,
    enabled = true,
    icon,
    ...rest
}: {
    enabled?: boolean;
    children: Children;
    disabledHelperText?: string;
    description?: Children;
    icon?: Children;
} & Omit<HorizontalStackProps, 'children'>): ReturnComponent => {
    // Tooltip functionality that shows either the disabled helper text or the description.
    const showDisabledHelperTextInsteadOfDescription = !enabled && disabledHelperText !== '';
    const tooltipContents = showDisabledHelperTextInsteadOfDescription
        ? disabledHelperText
        : description;

    return (
        <HorizontalStack spacing={1} {...rest}>
            {children}
            {description || showDisabledHelperTextInsteadOfDescription ? (
                <Tooltip
                    placement='right-start'
                    enterTouchDelay={0}
                    leaveTouchDelay={3000}
                    title={
                        <Typography variant='body2' sx={{ padding: 2 }}>
                            {tooltipContents}
                        </Typography>
                    }
                    slotProps={{
                        tooltip: {
                            sx: {
                                padding: 0,
                                maxWidth: '300px',
                                backgroundColor: 'background.paper',
                                color: 'text.primary',
                                boxShadow: 8,
                            },
                        },
                    }}
                >
                    <IconButton size='small' aria-label='More information' sx={{ padding: 0 }}>
                        {icon ?? <Info sx={{ fontSize: 15, color: 'primary.main' }} />}
                    </IconButton>
                </Tooltip>
            ) : null}
        </HorizontalStack>
    );
};
